export interface StartOAuthModel {
  redirectUri: string;
  verificationRef: string;
}
